import { FC } from 'react';
import intl from 'react-intl-universal';

interface ProjectResourcingTypeProps {
  resourcingType: string;
  className?: string;
}

const ProjectResourcingType: FC<ProjectResourcingTypeProps> = ({
  resourcingType,
  className,
}) => {
  if (!resourcingType || resourcingType.toUpperCase() === 'UNDEFINED') {
    return null;
  }

  return (
    <div className={className}>
      {intl.get(
        `PROJECT_DETAIL.RESOURCING_TYPE_OPTIONS.${resourcingType.toUpperCase()}`
      )}
    </div>
  );
};

export default ProjectResourcingType;
